import types from '../../types';

const hotWallets = (
  state = { loading: true, hot_address: null, data: null },
  { type, payload },
) => {
  switch (type) {
    // start
    case types.GET_WALLET_ADDRES_START:
    case types.UPDATE_HOT_WALLETS_START:
    case types.GET_HOT_WALLETS_START:
      return { ...state, loading: true };

    // success
    case types.GET_WALLET_ADDRES_SUCCESS:
      return {
        ...state,
        hot_address: payload.hot_address,
        loading: false,
      };
    case types.GET_HOT_WALLETS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };

    // failure
    case types.GET_WALLET_ADDRES_FAILURE:
    case types.UPDATE_HOT_WALLETS_FAILURE:
    case types.GET_HOT_WALLETS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default hotWallets;
